import { RavelElement } from '../../../base/ravel-element/src/RavelElement.js';
import globalStyles from '../../../../common/global-styles.js';
import { RavelEmoji } from '../../../../../modules/RavelEmoji.js';

export class RavelProgressiveComposition2 extends RavelElement {
    static get localStyles() {
        return `
        <style>
        #composition-grid {
            padding: 10px;
            display: grid;
            grid: auto / auto auto auto auto;
        }
        .grid-item {
            display: flex;
            flex-wrap: wrap;
            width: 76px;
            height: 56px;
            font-size: 14px;
            margin: 5px;
            padding-top: 2px;
            padding-left: 2px;
            border: 6px solid rgba(0, 0, 0, 0.9);
        }
        .background-0 {
            background-color: rgba(255, 255, 255, 0.8);
        }
        .background-1 {
            background-color: rgba(255, 255, 255, 0.75);
        }
        .background-2 {
            background-color: rgba(255, 255, 255, 0.70);
        }
        .background-3 {
            background-color: rgba(255, 255, 255, 0.65);
        }
        .background-4 {
            background-color: rgba(255, 255, 255, 0.60);
        }
        .background-5 {
            background-color: rgba(255, 255, 255, 0.55);
        }
        .background-6 {
            background-color: rgba(255, 255, 255, 0.50);
        }
        .background-7 {
            background-color: rgba(255, 255, 255, 0.45);
        }
        .background-8 {
            background-color: rgba(255, 255, 255, 0.40);
        }
        .background-9 {
            background-color: rgba(255, 255, 255, 0.35);
        }
        .background-10 {
            background-color: rgba(255, 255, 255, 0.30);
        }
        .background-11 {
            background-color: rgba(255, 255, 255, 0.25);
        }
        .background-12 {
            background-color: rgba(255, 255, 255, 0.20);
        }
        .performer {
            margin: 0px 2px;
        }
        </style>
        `;
    }
  
    static get html() { 
        return `
        <div id="container">
            <div id="composition-grid">
            </div>
        </div>
        `;
    }
 
    static get observedAttributes() { 
        return [...super.baseObservedAttributes, 'rows', 'cols', 'source'];
    }

    constructor() {
        super();
        const template = document.createElement('template');
        template.innerHTML = globalStyles
            + this.constructor.localStyles
            + this.constructor.html;
        this.attachShadow({ mode: 'open' });
        this.shadowRoot.appendChild(template.content.cloneNode(true));
        this.initialize();
    }
  
    connectedCallback() {
        this.setup();
    }
    
    disconnectedCallback() {
        this.teardown();
    }
    
    initialize() {
        this.container = this.shadowRoot.querySelector('#container');
        this.grid = this.shadowRoot.querySelector('#composition-grid');
        this.performers = 12;
        this.performerIcon = [];
        this.performerSection = [];
        this.sections = 12;
        this.autoplay = false;
        this.autoplayTimer = null;
        this.maxSection = 0;
        this.minSection = 0;
    }
  
    setup = () => {
        this.observedMessages = [];
        //this.subscribe(this.observedMessages);  
        for (let i = 0; i < this.sections; i ++) {
            this.grid.innerHTML += `
            <div id="composition-grid-item-${i}" class="grid-item background-${i}"></div>
            `;
        } 

        console.log('1');
        for (let i = 0; i < this.sections; i ++) {
            this.shadowRoot.querySelector(`#composition-grid-item-${i}`).addEventListener('click', (evt) => {
                console.log(`Clicked ${i}`);
                this.moveRandomPerformer(i);
            });
        } 
        console.log('2');
        for (let i = 0; i < this.performers; i ++) {
            //let icon = RavelEmoji.getRandomSquareColor();
            let icon = '⚫️';
            this.performerIcon.push(icon);
            this.performerSection.push(0);
            this.shadowRoot.querySelector(`#composition-grid-item-0`).innerHTML += `
            <span id="performer-${i}" class="performer">${icon}</span>
            `;
        }
        console.log('3');
        /*
        // FIXME: Add auto play
        this.shadowRoot.querySelector(`#auto-play`).addEventListener('click', (evt) => {
            console.log('auto play');
            this.autoplay = !this.autoplay;
            if (this.autoplay) {
                this.autoPlayTimer = setInterval(() => {
                        this.moveRandomPerformer(this.performerSection[Math.floor(Math.random() * this.performers)]);
                    },
                    200
                );
            } else {
                if (this.autoPlayTimer) clearInterval(this.autoPlayTimer);
            }
        });
        */
    }
    
    moveRandomPerformer(section) {
        let performersInSection = [];
        for (let i = 0; i < this.performerSection.length; i++) {
            if (this.performerSection[i] === section) {
                performersInSection.push(i);
            }
        }
        if (performersInSection.length > 0) {
            let n = performersInSection[Math.floor(Math.random() * performersInSection.length)];
            if (this.performerSection[n] < (this.sections -1)) {
                this.performerSection[n]++;
                let p = this.shadowRoot.querySelector(`#performer-${n}`);
                console.log(p);
                this.shadowRoot.querySelector(`#composition-grid-item-${this.performerSection[n]}`).appendChild(p);
                if (this.performerSection[n] > this.maxSection) this.maxSection = this.performerSection[n];
            } 
        }
    }
    
    teardown = () => {
       // this.unsubscribe(this.observedMessages);
    }

    attributeChangedCallback(name, oldValue, newValue) {
        // Call the parent's attributeChangedCallback to preserve its behavior
        super.attributeChangedCallback(name, oldValue, newValue);
        
        if (name === 'attribute') {
            // Do something
        }
    }
}
